import { css, styled } from '@mui/material/styles'

export const DisabledWrapper = styled('div')`
  ${(props: { disabled: boolean; opacity?: number }) =>
    props.disabled
      ? css`
          cursor: default;
          pointer-events: none;
          opacity: ${props.opacity ?? 0.2};
        `
      : ''}
`
